export const formatDate = date => {
    if (!date) return null

    const foramtter = new Intl.DateTimeFormat('en-GB')
    const formatedDate = foramtter.format(new Date(date))

    return formatedDate
}
